import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {fetchEntregaDetalle, fetchEntregaDetalleAdicional} from '../../../../actions';
import moment from 'moment';

const EntregaInfo = (props) => (

    <section className='fdv-section tab-pane active' id='entregaInfo'>
        <header className='fdv-section-head'>
            <h5 className='fdv-section-title'>Informaci&oacute;n de entrega</h5>
        </header>
        <div className='card card-plain card-lg'>
            <div className='row'>
                <div className='col-sm-4'>
                    <label className='labelInfo'>Transportista<i
                        className='Sociedad de Abogados y asociados S.A.C ml-2'/>
                    </label>
                    <p>{props.entrega.tipTrans}</p>
                </div>
                <div className='col-sm-4'>
                    <label className='labelInfo'>Tipo de entrega<i
                        className='Sociedad de Abogados y asociados S.A.C ml-2'/>
                    </label>
                    <p>{props.entrega.tipEnt}</p>
                </div>
                <div className='col-sm-4'>
                    <label className='labelInfo'>Responsable de entrega<i
                        className='Sociedad de Abogados y asociados S.A.C ml-2'/>
                    </label>
                    <p style={{textTransform: 'uppercase'}}>{props.entrega.nomUsuaResp}</p>
                </div>
            </div>
            <div className='row'>
                <div className='col-sm-4'>
                    <label className='labelInfo'>Personal adicional</label>
                    {props.personalAdicional.map((item) => (
                        <p style={{textTransform: 'uppercase'}}>{item.nomUsuAdic}<br/></p>
                    ))}
                </div>

                <div className='col-sm-4'>
                    <label className='labelInfo'>Entrega con placas</label>
                    <p>{props.entrega.numPlacaVeh ? 'NO' : 'SI'}</p>
                </div>
            </div>
        </div>
        <div className='card card-plain card-lg'>
            <div className='row'>
                <div className='col-sm-4'>
                    <label className='labelInfo'>Lugar de entrega<i
                        className='Sociedad de Abogados y asociados S.A.C ml-2'/>
                    </label>
                    <p>{props.entrega.lugarEntrega}</p>
                </div>
                <div className='col-sm-4'>
                {
                    props.entrega.lugarEntrega === 'CLIENTE' &&
                    <div>
                    <label className='labelInfo'>Direcci&oacute;n de entrega<i
                    className='Sociedad de Abogados y asociados S.A.C ml-2'/>
                    </label>
                    <p>{props.entrega.dirEntrVehi}</p>
                    </div>
                    }
                </div>
                <div className='col-sm-4'>
                    <label className='labelInfo'>Fecha de entrega<i
                        className='Sociedad de Abogados y asociados S.A.C ml-2'/>
                    </label>
                    <p>{props.entrega.fecProgramada ? moment(props.entrega.fecProgramada).format('DD/MM/YYYY HH:mm:ss') : ''}</p>
                </div>
            </div>
            <div className='row'>
                <div className='col-sm-4'>
                    <label className='labelInfo'>Contaco recepci&oacute;n</label>
                    <p>{props.entrega.nomContRece}</p>
                </div>
                <div className='col-sm-4'>
                    <label className='labelInfo'>Tel&eacute;fono</label>
                    <p>{props.entrega.telContRece}</p>
                </div>
                <div className='col-sm-4'>
                    <label className='labelInfo'>Email</label>
                    <p>{props.entrega.emaContRece}</p>
                </div>
            </div>
        </div>
        <div className='card card-plain card-lg'>
            <div className='row'>
                <div className='col-sm-12'>
                    <label className='labelInfo'>Observaciones</label>
                    <p>{props.entrega.obsEntrVeh ? props.entrega.obsEntrVeh : 'NO TIENE OBSERVACIONES'}</p>
                </div>
            </div>
        </div>
        <header className='fdv-section-head'>
            <h5 className='fdv-section-title'>Observaciones previas</h5>
        </header>
        <div className='card card-plain card-lg'>
            <div className='row'>
                <div className='col-sm-12'>
                    <div className='col-sm-7'>
                        <label className='labelInfo'>PROGRAMACION</label>
                    </div>
                    <div className='col-sm-5'>
                        <label className='labelInfo'><label
                            style={{textTransform: 'uppercase'}}>{props.entrega.nomUsuarioCrea}</label>
                            <label>{props.entrega.fecRegiPlan ? 'el ' + moment(props.entrega.fecRegiPlan).format('DD/MM/YYYY hh:mm') : ''}</label></label>
                    </div>
                    {
                        props.entrega.fecProgramada ?
                            <p>Se registró una programación de entrega.
                                Fecha y hora de programación de
                                entrega: {moment(props.entrega.fecProgramada).format('DD/MM/YYYY hh:mm')}.
                                Lugar de entrega: {props.entrega.tipLugar} - {props.entrega.lugarEntrega}.
                                Observación: {props.entrega.obsEntrVeh}</p>
                            :
                            <p>NO TIENE OBSERVACIONES</p>

                    }

                </div>
            </div>
        </div>
    </section>
)

class EntregaComponent extends Component {

    static hideMessage() {
        setTimeout(() => {
            if (document.getElementById('alertEntrega')) {
                document.getElementById('alertEntrega').style.display = 'none';
            }
        }, 3000);
    }

    constructor(props) {
        super(props);
        this.state = {
            estadoTrama: '',
            mensaje: '',
            entrega: [],
            personalAdicional: []
        }
    }

    handleClickEntrega() {
        this.props.loading('block')
        this.props.fetchEntregaDetalle(this.props.numPedidoVeh)
            .then((data) => {
                if (data.payload.data.entrega[0] != null) {
                    this.setState({entrega: data.payload.data.entrega[0]});

                    this.props.fetchEntregaDetalleAdicional(this.state.entrega.codPlanEntrVehi)
                        .then((data) => {
                            this.setState({personalAdicional: data.payload.data.personalAdicional});
                            this.props.loading('');
                        }).catch((error) => { console.log(error); });
                }
            }).catch((error) => { console.log(error); });
    }

    componentDidMount() {
        this.handleClickEntrega();
    }

    render() {
        return (
            <div>

                {this.state.entrega.fecProgramada ? (
                    <EntregaInfo
                        entrega={this.state.entrega}
                        personalAdicional={this.state.personalAdicional}
                        numPedidoVeh={this.state.numPedidoVeh}/>
                ) : (<div className='tableWrapper'>
                    <table className='table table-hover '>
                        <tr>
                            <td><p style={{textAling: 'center'}}>El pedido no cuenta con programación de entrega!!</p>
                            </td>
                        </tr>
                    </table>
                </div>)}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        entrega: state.entrega,
        personalAdicional: state.personalAdicional
    };
}


export default withRouter(
    connect(mapStateToProps, {fetchEntregaDetalle, fetchEntregaDetalleAdicional})(EntregaComponent)
);


// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/ItemsDetalle/EntregaComponent.js